import {
  GetCurrentSubscriptionOptions,
  getCurrentSubscription
} from '../../api/subscription-service/getCurrentSubscription'
import { Subscription } from '../../types/subscription'
import { UseAPIConfig, UseAPIOptions, UseAPIResponse, useAPI } from '../useAPI'
import { useAuthState } from '../../hooks/useAuthState'

export type UseSubscriptionOptions = UseAPIOptions<GetCurrentSubscriptionOptions>
export type UseSubscriptionConfig = UseAPIConfig<Subscription | undefined | null, Error>
export type UseSubscriptionResponse = UseAPIResponse<Subscription | undefined | null, Error>

/**
 * Wraps useSWR to retrieve subscription info from the api.
 */
export function useCurrentSubscriptionSWR(
  options: UseSubscriptionOptions,
  config?: UseSubscriptionConfig
): UseSubscriptionResponse {
  const authState = useAuthState()
  return useAPI<GetCurrentSubscriptionOptions, Subscription | undefined | null, Error>(
    'useCurrentSubscription',
    getCurrentSubscription,
    () => {
      const evaluatedOptions = typeof options === 'function' ? options() : options
      if (!evaluatedOptions) return
      if (!authState.token) return
      return {
        ...evaluatedOptions,
        token: authState.token
      }
    },
    config
  )
}
